<template>
    <div class="general-tab">
        <div
            class="tabulation-title"
            :style="'color:' + titlesColor">

            <h5 :class="uskaForm && 'mt-0'">{{ index }}.
               <span v-if="!newTitle">
                   Informations générales
               </span>
                <span v-else>
                    {{newTitle}}
                </span>
            </h5>
        </div>

        <v-alert type="info"
                 class="mb-5 form-container mr-auto ml-auto"
                 border="right"
                 :color="primaryColor"
                 colored-border
                 v-if="helpDesc"
        >
            <div>{{helpDesc}}</div>
        </v-alert>

        <div class="form-container mr-auto ml-auto mt-3">
            <form-component-loader :fields="tabulationFields"></form-component-loader>
        </div>
    </div>
</template>

<script>
import {mapState, mapGetters} from "vuex"
import FormComponentLoader from "../FormComponentLoader.vue"

export default {
    name: "General",
    components: {FormComponentLoader},
    props: ["index", "uskaForm", "newTitle", "helpDesc"],
    methods: {
        handleAIContent(res) {
            this.provider.contents.forEach((content) => {
                if (content.language.code === "fr") {
                    if (res.type === 'SHORT') {
                        content.description = res.content
                    } else {
                        content.description_long = res.content
                    }
                }
            })
        },
        handleTranslation(res) {
            this.provider.contents.forEach((content) => {
                if (content.language.code === "en") {
                    content.description_long = res.content
                }
            })
        }
    },
    computed: {
        ...mapState("web_form", ["provider"]),
        ...mapState("webFormStyle", ["titlesColor", 'primaryColor']),
        ...mapState("resource", ["languages"]),
        ...mapGetters("web_form", ["getFieldsFromTabulation"]),
        tabulationFields() {
            let categoryFields = this.getFieldsFromTabulation(this.provider.category.name).sort((a, b) => a.order - b.order)
            let partyMenu = categoryFields.find(field => field.fieldable.code === 'DESC_PARTY_MENU')

            let fields = this.getFieldsFromTabulation('GENERAL').sort((a, b) => a.order - b.order)

            if (partyMenu !== undefined) {
                fields.push(partyMenu)
            }

            return fields
        }
    },
    created() {
        this.$global.$on('accept-ai-content', this.handleAIContent)
        this.$global.$on('accept-translation', this.handleTranslation)
    },
    beforeDestroy() {
        this.$global.$off('accept-ai-content')
        this.$global.$off('accept-translation')
    }
}
</script>